import template from './ecocode-trustpilot-finish.html.twig';
import './ecocode-trustpilot-finish.scss';

const { Component } = Shopware;

Component.register('ecocode-trustpilot-finish', {
    template,
    emits:['frw-set-title','buttons-update'],
    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.updateButtons();
        },

        updateButtons() {
            const buttonConfig = [
                {
                    key: 'back',
                    label: this.$tc('sw-first-run-wizard.general.buttonBack'),
                    position: 'left',
                    variant: null,
                    action: 'ecocode.trustpilot.setup.invitation',
                    disabled: false
                },
                {
                    key: 'finish',
                    label: this.$tc('sw-first-run-wizard.general.buttonFinish'),
                    position: 'right',
                    variant: 'primary',
                    action: this.onFinish.bind(this),
                    disabled: false
                }
            ];

            this.$emit('buttons-update', buttonConfig);
        },

        onFinish() {
            this.$emit('modal-close');
        }
    }
});
